import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

const usePayrollAction = () => {
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);
  // -----------state user_shop_departments---------
  const [storage_host_cluster_Id, setStorage_host_cluster_Id] = useState<any>();
  const [departmentPayroll, setDepartmentPayroll] = useState<any>();
  const [payrollSetting, setPayrollSetting] = useState<any>();
  const [loadingDepartmentTimeSheet, setloadingDepartmentTimeSheet] = useState<boolean>(false);
  const getShopEmployeePayrollDepartment = async () => {
    setloadingDepartmentTimeSheet(true);
    try {
      const url = `${RouteApi.getShopEmployeePayrollDepartment}token=${token}`;
      const data = {
        shop_id: shopId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setloadingDepartmentTimeSheet(false);
        setDepartmentPayroll(response.user_shop_departments);
        setStorage_host_cluster_Id(response.storage_host_cluster);
        setPayrollSetting(response.payroll_setting);
      } else {
        setloadingDepartmentTimeSheet(false);
        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
      }
    } catch (error) {
      setloadingDepartmentTimeSheet(false);
      AppLog.show({
        message: `[getShopEmployeePayrollDepartment]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  // -------------state submit setting--------
  const [openPopoverSetting, setOpenPopoverSetting] = useState<number | null>(null);

  const [formValues, setFormValues] = useState<any>({
    payroll_pay_option: payrollSetting?.payroll_pay_option || "",
    seniority_tax_allowance: payrollSetting?.seniority_tax_allowance,
    transport_allownace: false,
    housing_allownace: false,
    phone_allownace: false,
    food_allownace: false,
    other_allownace: false,
    commission_pay: false,
    seniority_pay: false,
    advance_pay: false,
    overtime_pay: false,
    loan_deduction: false,
    advance_deduction: false,
    attendance_deduction: false,
    other_deduction: false,
    pension_deduction: false,
  });
  const [loadingsubmitShopPayrollSetting, setLoadingsubmitShopPayrollSetting] = useState<boolean>(false);
  const submitShopPayrollSetting = async () => {
    setLoadingsubmitShopPayrollSetting(true);
    try {
      const url = `${RouteApi.submitShopPayrollSetting}token=${token}`;
      const updatedFormValues = {
        ...formValues,
        tax_settings: payrollSetting.tax_settings, // Push tax_settings into formValues
      };
      const data = {
        shop_id: shopId,
        setting: updatedFormValues,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setPayrollSetting((prev: any) => (prev?.id === response.payroll_setting?.id ? response.payroll_setting : prev));

        setLoadingsubmitShopPayrollSetting(false);
        setOpenPopoverSetting(null);
      } else {
      }
    } catch (error) {
      setLoadingsubmitShopPayrollSetting(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  return {
    // state user shop department
    getShopEmployeePayrollDepartment,
    loadingDepartmentTimeSheet,
    setloadingDepartmentTimeSheet,
    payrollSetting,
    setPayrollSetting,
    departmentPayroll,
    setDepartmentPayroll,
    storage_host_cluster_Id,
    setStorage_host_cluster_Id,
    errorStatus,
    setErrorStatus,
    warning,
    setWarning,

    // state submit setting
    openPopoverSetting,
    setOpenPopoverSetting,
    formValues,
    setFormValues,
    loadingsubmitShopPayrollSetting,
    submitShopPayrollSetting,
  };
};

export default usePayrollAction;
